import {useBoxes, useOccupancies, usePlatform} from "@variocube/cube-ui";
import * as React from "react";
import {useMemo} from "react";
import {BoxTable} from "./BoxTable";
import {Shop} from "../types";

export interface BoxTabProps {
    shop: Shop;
    allowOpenNonOccupied: boolean;
}

export function BoxTab({shop, allowOpenNonOccupied}: BoxTabProps) {
    const platform = usePlatform();
    const boxes = useBoxes();
    const occupancies = useOccupancies();

    const items = useMemo(() => {
        const occupiedBoxes = platform.getOccupiedBoxes();
        const shopOccupancies = occupancies.filter(occupancy => shop.orders.find(({id}) => id == occupancy.content.order?.id));

        return boxes.map(box => {
            const occupied = !!occupiedBoxes.find(({number}) => number == box.number);
            const occupancy = shopOccupancies.filter(occupancy => occupancy.boxNumber == box.number).pop();
            return {
                box,
                occupancy,
                occupied,
            }
        });
    }, [platform, boxes, occupancies]);

    return (
        <BoxTable items={items} allowOpenNonOccupied={allowOpenNonOccupied}/>
    )
}
